export const ADMIN_PAGE_GET_REQUEST = "ADMIN_PAGE_GET_REQUEST";
export const ADMIN_PAGE_GET_SUCCESS = "ADMIN_PAGE_GET_SUCCESS";
export const ADMIN_PAGE_GET_FAIL = "ADMIN_PAGE_GET_FAIL";

export const ADMIN_PAGES_GET_REQUEST = "ADMIN_PAGES_GET_REQUEST";
export const ADMIN_PAGES_GET_SUCCESS = "ADMIN_PAGES_GET_SUCCESS";
export const ADMIN_PAGES_GET_FAIL = "ADMIN_PAGES_GET_FAIL";

export const ADMIN_PAGE_UPDATE_REQUEST = "ADMIN_PAGE_UPDATE_REQUEST";
export const ADMIN_PAGE_UPDATE_SUCCESS = "ADMIN_PAGE_UPDATE_SUCCESS";
export const ADMIN_PAGE_UPDATE_FAIL = "ADMIN_PAGE_UPDATE_FAIL";

export const ADMIN_PAGE_CREATE_REQUEST = "ADMIN_PAGE_CREATE_REQUEST";
export const ADMIN_PAGE_CREATE_SUCCESS = "ADMIN_PAGE_CREATE_SUCCESS";
export const ADMIN_PAGE_CREATE_FAIL = "ADMIN_PAGE_CREATE_FAIL";

export const ADMIN_PAGE_GENERATE_REQUEST = "ADMIN_PAGE_GENERATE_REQUEST";
export const ADMIN_PAGE_GENERATE_SUCCESS = "ADMIN_PAGE_GENERATE_SUCCESS";
export const ADMIN_PAGE_GENERATE_FAIL = "ADMIN_PAGE_GENERATE_FAIL";
export const ADMIN_PAGE_GENERATE_RESET = "ADMIN_PAGE_GENERATE_RESET";

export const ADMIN_PAGE_PRESET_SAVE_REQUEST = "ADMIN_PAGE_PRESET_SAVE_REQUEST";
export const ADMIN_PAGE_PRESET_SAVE_SUCCESS = "ADMIN_PAGE_PRESET_SAVE_SUCCESS";
export const ADMIN_PAGE_PRESET_SAVE_FAIL = "ADMIN_PAGE_PRESET_SAVE_FAIL";

export const ADMIN_PAGE_PRESET_GET_REQUEST = "ADMIN_PAGE_PRESET_GET_REQUEST";
export const ADMIN_PAGE_PRESET_GET_SUCCESS = "ADMIN_PAGE_PRESET_GET_SUCCESS";
export const ADMIN_PAGE_PRESET_GET_FAIL = "ADMIN_PAGE_PRESET_GET_FAIL";

export const ADMIN_PAGE_PRESET_REMOVE_REQUEST = "ADMIN_PAGE_PRESET_REMOVE_REQUEST";
export const ADMIN_PAGE_PRESET_REMOVE_SUCCESS = "ADMIN_PAGE_PRESET_REMOVE_SUCCESS";
export const ADMIN_PAGE_PRESET_REMOVE_FAIL = "ADMIN_PAGE_PRESET_REMOVE_FAIL";

export const ADMIN_PAGE_VERSION_GET_REQUEST = "ADMIN_PAGE_VERSION_GET_REQUEST";
export const ADMIN_PAGE_VERSION_GET_SUCCESS = "ADMIN_PAGE_VERSION_GET_SUCCESS";
export const ADMIN_PAGE_VERSION_GET_FAIL = "ADMIN_PAGE_VERSION_GET_FAIL";

export const ADMIN_PAGE_VERSIONS_GET_REQUEST = "ADMIN_PAGE_VERSIONS_GET_REQUEST";
export const ADMIN_PAGE_VERSIONS_GET_SUCCESS = "ADMIN_PAGE_VERSIONS_GET_SUCCESS";
export const ADMIN_PAGE_VERSIONS_GET_FAIL = "ADMIN_PAGE_VERSIONS_GET_FAIL";

export const ADMIN_PAGE_VERSION_CHANGE_REQUEST = "ADMIN_PAGE_VERSION_CHANGE_REQUEST";
export const ADMIN_PAGE_VERSION_CHANGE_SUCCESS = "ADMIN_PAGE_VERSION_CHANGE_SUCCESS";
export const ADMIN_PAGE_VERSION_CHANGE_FAIL = "ADMIN_PAGE_VERSION_CHANGE_FAIL";
